import React from 'react';

interface GenerateMeasurementEngProps {
    fill?: string;
}

export const GenerateMeasurementEng = ({ fill = 'currentColor' }: GenerateMeasurementEngProps) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.0391 6V14.5312H12.9883V6H15.0391Z" fill={fill} />
        <path
            d="M8.28906 7.79297L6.20898 14.5312H4L7.13477 6H8.53516L8.28906 7.79297ZM10.0117 14.5312L7.92578 7.79297L7.65625 6H9.07422L12.2266 14.5312H10.0117ZM9.92969 11.3496V12.9375H5.55273V11.3496H9.92969Z"
            fill={fill}
        />
    </svg>
);
